import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import marketplacePropertiesService from '../../../../services/MarketplacePropertiesService';
import styles from './audioScriptOverlay.scss'; // Import as a module


const AudioScriptOverlay = ({ model }) => {
    if (!model.script) return null;
    const cleanedScript = model.script
        .replace(/<itemBody[^>]*>/i, '')
        .replace(/<h1>.*?<\/h1>/i, '')
        .replace(/<\/itemBody>/i, '');

    const sanitizedScript = DOMPurify?.sanitize(cleanedScript);
    const isBorderHidden = marketplacePropertiesService.shouldHideGridLinesInAudioScript();

    return (
        <div className={`${styles.audioScriptOverlay}${isBorderHidden ? ` ${styles.remove_border}` : ''}`}>
            <div
                dangerouslySetInnerHTML={{ __html: sanitizedScript }}
            />
        </div>
    );
};

AudioScriptOverlay.propTypes = {
    model: PropTypes.shape({
        script: PropTypes.string.isRequired,
    }).isRequired,
};

export default AudioScriptOverlay;
